import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import RevenueCentersForm from 'components/RevenueCenters/Form'

import { loadGlobalItems } from 'store/Items/actions'
import { getIsItemsLoading } from 'store/Items/selector'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import { getIsMerchantsLoading } from 'store/Merchants/selectors'
import { fetchMerchants } from 'store/Merchants/actions'
import { getIsMenusLoading } from 'store/Menus/selectors'
import { loadMenus } from 'store/Menus/actions'
import useEmailAuth from 'hooks/useEmailAuth'
import { loadConfigurationModels } from 'store/ConfigurationModels/actions'
import { getIsLoadingConfigurationModels } from 'store/ConfigurationModels/selectors'
import { fetchSettingsForStands } from 'store/Settings/actions'
import { getOrgName } from 'store/AppState/selector'

const RevenueCentersDetailsPage = () => {
  const dispatch = useDispatch()

  const venueUuid = useSelector(getCurrentVenueUuid)
  const organizationName = useSelector(getOrgName)
  const isVenueNexter = useEmailAuth()

  const isItemsLoading = useSelector(getIsItemsLoading)
  const isMerchantsLoading = useSelector(getIsMerchantsLoading)
  const isMenusLoading = useSelector(getIsMenusLoading)
  const isConfigurationModelLoading = useSelector(
    getIsLoadingConfigurationModels
  )

  const isLoading =
    isItemsLoading ||
    isMerchantsLoading ||
    isMenusLoading ||
    isConfigurationModelLoading

  useEffect(() => {
    dispatch(loadGlobalItems(venueUuid))
    dispatch(fetchMerchants({ venueUuid }))
    dispatch(loadMenus(venueUuid, isVenueNexter))
    dispatch(loadConfigurationModels(organizationName))
    dispatch(fetchSettingsForStands(venueUuid))
  }, [venueUuid, dispatch, isVenueNexter])

  return <RevenueCentersForm isLoading={isLoading} />
}

export default RevenueCentersDetailsPage
